import { Stack, Tab, Tabs } from '@mui/material'
import { NavLink, useLocation } from 'react-router-dom'
import { TabsStyle } from './style'

export const EventsTabs = () => {
  const { pathname } = useLocation()

  const currentTab = pathname.endsWith('/team-space')
    ? 4
    : pathname.endsWith('/social-orders')
      ? 3
      : pathname.endsWith('/requests')
        ? 2
        : pathname.endsWith('/replies')
          ? 1
          : 0

  return (
    <Stack direction="column" gap={{ xs: 1.5, sm: 2 }} mb={2} sx={{ minWidth: 0 }}>
      <Tabs
        value={currentTab}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={TabsStyle}
      >
        <Tab label="Все" component={NavLink} to="/" end />
        <Tab label="Ответы" component={NavLink} to="/replies" />
        <Tab label="Запросы" component={NavLink} to="/requests" />
        <Tab label="Соц-заказы" component={NavLink} to="/social-orders" />
        <Tab label="Командное пространство" component={NavLink} to="/team-space" />
      </Tabs>
    </Stack>
  )
}
